import React from "react";
import axios from "axios";
import StripeCheckout from "react-stripe-checkout";

import Sunset from "../components/Sunset";

import STRIPE_PUBLISHABLE from "../constants/stripe";
import PAYMENT_SERVER_URL from "../constants/server";

import vinyl from "../images/vinyl.jpg";

import "../styles/Buy.css";

const CURRENCY = "USD";

const fromDollarToCent = amount => amount * 100;

const successPayment = data => {
    alert("Payment Successful");
};

const errorPayment = data => {
    alert("Payment Error");
};

const onToken = (amount, description) => token =>
    axios
        .post(PAYMENT_SERVER_URL, {
            description,
            source: token.id,
            currency: CURRENCY,
            amount: fromDollarToCent(amount),
        })
        .then(successPayment)
        .catch(errorPayment);

const Buy = ({ name, description, amount, email }) => (
    <div>
        <Sunset />
        <div className="buy-container mt-5 mb-5 text-white">
            <img src={vinyl} alt="vinyl artwork" className="vinyl" />
            <div className="lead buy-text">
                Keep On Movin' (2015) 180g Vinyl Record
            </div>
            <br />
            <StripeCheckout
                className="mt-1 mb-5"
                name={name}
                description={description}
                amount={fromDollarToCent(amount)}
                shippingAddress
                token={onToken(amount, description)}
                currency={CURRENCY}
                stripeKey={STRIPE_PUBLISHABLE}
            />
        </div>
    </div>
);

export default Buy;



// WEBPACK FOOTER //
// ./src/components/Buy.js